/**
 * Restock Alert overlay
 * Affiche un texte + lien sur la photo produit quand le variant
 * sélectionné/affiché est en rupture de stock, pour ouvrir la popup
 * d'inscription de l'app Seal Back In Stock.
 *
 * - Fiche produit : le vrai widget de l'app (#sealapps-bis-widget,
 *   rendu plus bas sur la page par l'app block) est déplacé dans
 *   l'overlay sur la photo et restylé en CSS. Un clic JS simulé sur
 *   ce bouton n'ouvre pas sa popup (probablement une vérification
 *   `event.isTrusted`), donc on déplace le vrai bouton au lieu d'en
 *   simuler un.
 * - Product card en collection : l'app n'étant pas présente sur ces
 *   pages, on redirige vers la fiche produit avec le variant en
 *   rupture présélectionné ; l'utilisateur y voit directement le
 *   vrai bouton (repositionné) sur la photo.
 */
(function () {
  var LOG_PREFIX = '[restock-alert]';

  function relocateSealAppsWidget() {
    var slot = document.querySelector('[data-restock-alert-slot]');
    if (!slot) return;

    var attempts = 0;
    var maxAttempts = 20; // ~5s, the app may inject its widget asynchronously

    var interval = setInterval(function () {
      attempts++;
      var widget = document.getElementById('sealapps-bis-widget');

      if (widget) {
        clearInterval(interval);
        slot.appendChild(widget);
        widget.classList.add('restock-alert__seal-widget');
        console.log(LOG_PREFIX, 'Seal Back In Stock widget relocated into the image overlay', widget);
        nudgeVariantChangeEvent();
        return;
      }

      if (attempts >= maxAttempts) {
        clearInterval(interval);
        console.warn(
          LOG_PREFIX,
          '#sealapps-bis-widget not found after ' + maxAttempts + ' attempts - nothing to relocate.'
        );
      }
    }, 250);
  }

  /**
   * When the page loads with a variant already selected via the URL
   * (?variant=X, e.g. coming from a collection card), no real "variant
   * change" ever happens, so apps that only wire themselves up in
   * response to that event (like Seal Back In Stock appears to) stay
   * inert even though their widget is visible. Dawn's own product-info.js
   * dispatches a `change` event on the variant id input whenever the
   * shopper switches variants - we replay that same signal once after
   * load so those integrations get a chance to activate.
   */
  function nudgeVariantChangeEvent() {
    setTimeout(function () {
      var input = document.querySelector('product-info .product-variant-id');
      if (!input) return;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      console.log(LOG_PREFIX, 'Replayed variant change event on', input);
    }, 300);
  }

  function initProductPageSync() {
    var wrapper = document.querySelector('[data-restock-alert][data-context="product"]');
    if (!wrapper || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    var sectionId = wrapper.dataset.sectionId;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event.data.sectionId !== sectionId) return;
      wrapper.classList.toggle('restock-alert--visible', event.data.variant?.available === false);
    });
  }

  // Collection card: clicking the overlay redirects to the product page with
  // the out-of-stock variant preselected (no app widget exists on collection
  // pages to relocate or click).
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-restock-alert-trigger]');
    if (!trigger) return;

    var wrapper = trigger.closest('[data-restock-alert][data-context="card"]');
    if (!wrapper) return;

    event.preventDefault();
    event.stopPropagation();

    var url = wrapper.dataset.productUrl;
    var variantId = wrapper.dataset.variantId;
    console.log(LOG_PREFIX, 'Card trigger clicked, redirecting to', url, 'variant', variantId);
    if (url) {
      window.location.href = url + (variantId ? '?variant=' + variantId : '');
    }
  });

  function init() {
    initProductPageSync();
    relocateSealAppsWidget();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
